/* eslint-disable @typescript-eslint/no-explicit-any */
import { JSX, Suspense, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import ProfileContentLangTab from "@/components/gate/create-profile/ProfileContentLangTab";
import ProfileLangTab from "@/components/gate/create-profile/ProfileLangTab";
import ProfileRecommendationsTab from "@/components/gate/create-profile/ProfileRecommendationsTab";
import SetCodeToProfile from "@/components/gate/create-profile/SetCodeToProfile";
import ChooseKidProfile from "@/components/gate/profiles/ChooseKidProfile.tsx";
import ChooseProfile from "@/components/gate/profiles/ChooseProfile.tsx";
import ChooseProfileImage from "@/components/gate/profiles/ChooseProfileImage";
import { ProfileTabs } from "@/components/gate/profiles/types.ts";
import GroupTransition from "@/components/helpers/GroupTransition/GroupTransition.tsx";
import Loader from "@/components/helpers/Loader.tsx";

import { ProfilePicture } from "@/api/user/user.types";
import { useSelectProfileList } from "@/hooks/api/login.hooks.ts";
import { cn } from "@/utils/cn.ts";

import CodeForProfile from "./CodeForProfile";
import CreateProfilePage from "./CreateProfilePage";

export type ProfileForm = {
  name: string;
  gender: "M" | "W";
  date_of_birth: string;
  picture: ProfilePicture["picture"] | null;
  picture_id: number | null;
  pin_code: string;
  interface_lang: string;
  content_all: boolean;
  content_uz: boolean;
  content_ru: boolean;
  selected_content?: string[];
};

const PAGES: Record<ProfileTabs, React.ComponentType<any>> = {
  profiles: ChooseProfile,
  "kid-profiles": ChooseKidProfile,
  "add-profile": CreateProfilePage,
  pin: SetCodeToProfile,
  "open-pin": CodeForProfile,
  image: ChooseProfileImage,
  "profile-lang": ProfileLangTab,
  "content-lang": ProfileContentLangTab,
  movies: ProfileRecommendationsTab,
};

const ProfilesPage = (): JSX.Element => {
  const { state } = useLocation();
  // const navigate = useNavigate();

  const { data } = useSelectProfileList();
  const [profileId, setProfileId] = useState<number | null>(null);
  const [isEdit, setIsEdit] = useState(false);

  const formMethods = useForm<ProfileForm>({
    mode: "onSubmit",
  });

  // useEffect(() => {
  //   if (data?.status === 401) {
  //     removeLoginInfo();
  //     navigate("/");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  const [tab, setTab] = useState<ProfileTabs>(state?.isKids ? ProfileTabs.KID_PROFILES : ProfileTabs.PROFILES);

  useEffect(() => {
    // setting isKids to false in the state due to the fact that if it is true and user is in main profile choose the profile and goes back, the state will be saved and the user will be redirected to the kid-profiles page
    if (state?.isKids) {
      window.history.replaceState({ ...state, isKids: false }, document.title);
    }
  }, [state]);

  const PageComponent = useMemo(() => PAGES[tab], [tab]);

  return (
    <FormProvider {...formMethods}>
      <GroupTransition<HTMLDivElement> transitionKey={tab}>
        {({ ref }) => (
          <div
            ref={ref}
            className={cn("flex w-full flex-1 justify-center", {
              "max-md:flex-col max-md:justify-start max-md:p-4": tab === "kid-profiles",
            })}
          >
            <Suspense fallback={<Loader />}>
              {
                <PageComponent
                  profiles={data.data}
                  setTab={setTab}
                  setProfileId={setProfileId}
                  profileId={profileId}
                  setIsEdit={setIsEdit}
                  isEdit={isEdit}
                />
              }
            </Suspense>
          </div>
        )}
      </GroupTransition>
    </FormProvider>
  );
};

export default ProfilesPage;
